import React, { ReactNode } from "react";

import Box from "veneer/Box";
import Stack from "veneer/Stack";
import styled from "veneer/styled";
import { Colors } from "veneer/Theme";
import Typography from "veneer/Typography";

import { ENV } from "cortex/ui/src/constant/app";
import logoImage from "cortex/ui/static/image/vm-logo-stacked-white.svg";

const { APP_NAME } = ENV;

interface BaseLoginViewProps {
  children: ReactNode;
  width?: number | string;
}

const AppHeader = styled(Typography)({
  fontSize: "5.5rem",
  fontFamily: "Rajdhani",
  fontWeight: 800,
  lineHeight: 1,
  textAlign: "center",
  textTransform: "uppercase",
});

const LoginForm = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.shape.borderRadius,
  boxShadow:
    "0px 1px 18px 0px rgba(0, 0, 0, 0.12), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 3px 5px -1px rgba(0, 0, 0, 0.2)",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  padding: theme.spacing(6),
}));

const Container = styled(Stack)({
  backgroundColor: Colors.blue900,
});

const FooterBar = styled(Box)(({ theme }) => ({
  backgroundColor: Colors.blue1000,
  bottom: 0,
  color: Colors.white,
  padding: theme.spacing(2),
  position: "fixed",
  width: "100%",

  a: {
    color: Colors.white,
    textDecoration: "underline",
  },
  "a:hover": {
    color: Colors.white,
    textDecoration: "none",
  },
}));

export default function BaseLoginView({
  children,
  width = 400,
}: BaseLoginViewProps) {
  const headerColor = APP_NAME === "zeus" ? Colors.orange600 : Colors.blue900;
  const appName = APP_NAME === "zeus" ? "Zeus" : "Cortex";

  return (
    <Container
      alignItems="center"
      gap={2}
      justifyContent="center"
      minHeight="100vh"
    >
      <LoginForm width={width}>
        <AppHeader color={headerColor}>{appName}</AppHeader>
        {children}
      </LoginForm>
      <Box width={100}>
        <img alt="Logo" src={logoImage} width="100%" />
      </Box>
      <FooterBar>
        <Typography align="center" color="inherit" variant="h5">
          Need more information or help?{" "}
          <a
            href="https://help.vistarmedia.com/hc/en-us"
            rel="noopener noreferrer"
            target="_blank"
          >
            Visit our Knowledge Base
          </a>
        </Typography>
      </FooterBar>
    </Container>
  );
}
